import { render, staticRenderFns } from "./LoaConsultation.vue?vue&type=template&id=427cf5d2&"
import script from "./LoaConsultation.vue?vue&type=script&lang=js&"
export * from "./LoaConsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports